import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import { withTheme } from 'styled-components'
import { Tabs, Select, Radio } from 'antd'
import moment from 'moment'

import { Flex, FlexColumn } from '../../Reusable/Container'
import { Button, TextButton, Chip, ImageButton } from '../../Reusable/Button'
import { LabeledInput } from '../../Reusable/Input'
import { Text } from '../../Reusable/Text'
import { Dropdown, Menu } from '../../Reusable/Dropdown'
import Search from '../../../Images/search.png'
import FilterIcon from '../../../Images/filter.png'
import { Image } from '../../Reusable/Image'

const { TabPane } = Tabs;
const { Option } = Select;

const BILL_STATUSES = [
    { value: 'Unpaid', label: 'Unpaid' },
    { value: 'Scheduled', label: 'Scheduled' },
    { value: 'Paid', label: 'Paid' }
];

class SearchFilter extends Component {
    state = {
        dropdownVisible: false,
        searchTerm: '',
        fromDate: null,
        toDate: null,
        fromAmount: null,
        toAmount: null,
        status: null,
        tab: 'status',
        amountError: false
    }

    componentDidMount() {
        // Initialize state with active filters from props if available
        const { activeFilters } = this.props;
        if (activeFilters) {
            this.setState({
                searchTerm: activeFilters.searchTerm || '',
                fromDate: activeFilters.fromDate ? moment(activeFilters.fromDate) : null,
                toDate: activeFilters.toDate ? moment(activeFilters.toDate) : null,
                fromAmount: activeFilters.fromAmount,
                toAmount: activeFilters.toAmount,
                status: activeFilters.status
            });
        }
    }

    onTabChange = tab => {
        this.setState({ tab });
    }

    handleSearchChange = (e) => {
        const searchValue = e.target.value; // Capture value immediately
        this.setState({ searchTerm: searchValue });
        
        // Apply search filter with slight delay
        if (this.searchTimeout) {
            clearTimeout(this.searchTimeout);
        }
        
        this.searchTimeout = setTimeout(() => {
            console.log("Applying search filter:", searchValue);
            this.props.onFilterChange({ searchTerm: searchValue });
        }, 500);
    }

    applyStatusFilter = () => {
        const { status } = this.state;
        if (!status) return;
        
        // Apply the filter and close the dropdown
        console.log('Applying status filter:', status);
        this.props.onFilterChange({ status });
        
        // Manually close the dropdown after applying filter
        setTimeout(() => {
            this.setState({ dropdownVisible: false });
        }, 100);
    }

    applyDateFilter = () => {
        const { fromDate, toDate } = this.state;
        if (!fromDate || !toDate) return;
        
        this.props.onFilterChange({ 
            fromDate: fromDate.format('YYYY-MM-DD'),
            toDate: toDate.format('YYYY-MM-DD')
        });
        this.setState({ dropdownVisible: false });
    }
    
    applyAmountFilter = () => {
        const { fromAmount, toAmount } = this.state;
        
        // Validate amount range
        if (fromAmount > toAmount) {
            this.setState({ amountError: "To amount should be greater than or equal to From amount" });
            return;
        }
        
        if (fromAmount === 0 && toAmount === 0) {
            this.setState({ amountError: "Please enter an amount greater than $0" });
            return;
        }
        
        // Apply filter
        this.props.onFilterChange({ fromAmount, toAmount });
        this.setState({ dropdownVisible: false, amountError: false });
    }

    renderFilterChips = () => {
        const { activeFilters } = this.props;
        if (!activeFilters) return null;
        
        return (
            <Flex start wrap gap='8px' centerHorizontally>
                {activeFilters.searchTerm && (
                    <Chip 
                        closable 
                        onDelete={() => {
                            this.setState({ searchTerm: '' });
                            this.props.onFilterChange({ searchTerm: null });
                        }}
                        text={`"${activeFilters.searchTerm}"`} 
                    />
                )}
                
                {activeFilters.fromDate && activeFilters.toDate && (
                    <Chip 
                        closable 
                        onDelete={() => {
                            this.setState({ fromDate: null, toDate: null });
                            this.props.onFilterChange({ 
                                fromDate: null, 
                                toDate: null 
                            });
                        }}
                        text={`Due Date: ${moment(activeFilters.fromDate).format('ll')} - ${moment(activeFilters.toDate).format('ll')}`} 
                    />
                )}
                
                {activeFilters.fromAmount !== null && activeFilters.fromAmount !== undefined && 
                 activeFilters.toAmount !== null && activeFilters.toAmount !== undefined && (
                    <Chip 
                        closable 
                        onDelete={() => {
                            this.setState({ fromAmount: null, toAmount: null });
                            this.props.onFilterChange({ 
                                fromAmount: null, 
                                toAmount: null 
                            });
                        }}
                        text={`Amount: $${activeFilters.fromAmount} - $${activeFilters.toAmount}`} 
                    />
                )}
                
                {activeFilters.status && (
                    <Chip 
                        closable 
                        onDelete={() => {
                            this.setState({ status: null });
                            this.props.onFilterChange({ status: null });
                        }}
                        text={`Status: ${activeFilters.status}`} 
                    />
                )}
            </Flex>
        )
    }

    render() {
        const {
            searchTerm,
            fromDate,
            toDate,
            fromAmount,
            toAmount,
            status,
            dropdownVisible,
            tab,
            amountError
        } = this.state;
        
        const { theme, activeFilters, showStatusFilter, hideSearch } = this.props;
        const hasActiveFilters = activeFilters && Object.keys(activeFilters).length > 0;

        return (
            <Flex between centerHorizontally gap='12px'>
                <Flex centerHorizontally between fullWidth gap='16px'>
                    {
                        !hideSearch && 
                        <FlexColumn start>
                            <Flex start>
                                <LabeledInput
                                    id="searchTerm"
                                    nomargin
                                    width='220px'
                                    placeholder="Search by Vendor and No."
                                    prefixIcon={<img width='12px' height='12px' src={Search} />}
                                    value={searchTerm}
                                    onChange={this.handleSearchChange}
                                />
                            </Flex>
                        </FlexColumn>
                    }

                    {hasActiveFilters && (
                        <Flex end fullWidth>
                            <Flex between fullWidth centerHorizontally>
                                {this.renderFilterChips()}
                            </Flex>
                        </Flex>
                    )}

                    <Flex gap='12px' centerHorizontally>
                        {hasActiveFilters && (
                            <Text 
                                primary 
                                noWrap 
                                underline 
                                style={{ cursor: 'pointer' }} 
                                onClick={() => {
                                    this.setState({
                                        searchTerm: '',
                                        fromDate: null,
                                        toDate: null,
                                        fromAmount: null,
                                        toAmount: null,
                                        status: null,
                                        tab: 'status',
                                        amountError: false
                                    });
                                    this.props.onClearAll();
                                }}
                            >
                                Clear all
                            </Text>
                        )}

                        <Dropdown
                            placement='bottomRight'
                            trigger='click'
                            onVisibleChange={(flag) => this.setState({ dropdownVisible: flag })}
                            visible={dropdownVisible}
                            destroyPopupOnHide={false} // Prevent dropdown from being destroyed when hidden
                            overlay={(
                                <Menu 
                                    onClick={(e) => {
                                        // Stop click event propagation to prevent dropdown from closing
                                        e && e.domEvent && e.domEvent.stopPropagation();
                                    }} 
                                    style={{ width: 600, padding: '12px 24px 24px', borderRadius: 8 }}
                                >
                                    <Tabs 
                                        onClick={(e) => {
                                            // Stop click event propagation
                                            e && e.stopPropagation();
                                        }} 
                                        onChange={this.onTabChange}
                                    >
                                        {showStatusFilter && (
                                            <TabPane tab="Status" key="status">
                                                <FlexColumn left gap='24px'>
                                                    <div 
                                                        onClick={(e) => e.stopPropagation()} 
                                                        style={{ padding: '10px 0' }}
                                                    >
                                                        <Radio.Group 
                                                            value={status} 
                                                            onChange={(e) => {
                                                                console.log("Radio onChange", e.target.value);
                                                                this.setState({ status: e.target.value });
                                                            }}
                                                            style={{ width: '100%' }}
                                                        >
                                                            <Flex start gap='12px' style={{ width: '100%' }}>
                                                                {BILL_STATUSES.map(statusOption => (
                                                                    <Radio key={statusOption.value} value={statusOption.value}>
                                                                        {statusOption.label}
                                                                    </Radio>
                                                                ))}
                                                            </Flex>
                                                        </Radio.Group>
                                                    </div>
                                                    <Button 
                                                        solid 
                                                        disabled={!status} 
                                                        text='APPLY' 
                                                        onClick={(e) => {
                                                            // Stop propagation to prevent dropdown closing prematurely
                                                            e.stopPropagation();
                                                            console.log("Apply button clicked with status:", status);
                                                            this.applyStatusFilter();
                                                        }} 
                                                    />
                                                </FlexColumn>
                                            </TabPane>
                                        )}

                                        <TabPane tab="Due Date" key="dueDate">
                                            <FlexColumn left gap='24px'>
                                                <Flex between gap='24px'>
                                                    <LabeledInput
                                                        label="From"
                                                        type="date-picker"
                                                        disabledDate={(date) => toDate ? date > toDate : false}
                                                        placeholder='MM/DD/YYYY'
                                                        value={fromDate}
                                                        format={'MM/DD/YYYY'}
                                                        onChange={(date) => this.setState({ fromDate: date })}
                                                    />
                                                    <LabeledInput
                                                        label="To"
                                                        type="date-picker"
                                                        disabledDate={(date) => fromDate ? date < fromDate : false}
                                                        placeholder='MM/DD/YYYY'
                                                        value={toDate}
                                                        format={'MM/DD/YYYY'}
                                                        onChange={(date) => this.setState({ toDate: date })}
                                                    />
                                                </Flex>
                                                <Button 
                                                    solid 
                                                    disabled={!fromDate || !toDate} 
                                                    text='APPLY' 
                                                    onClick={this.applyDateFilter} 
                                                />
                                            </FlexColumn>
                                        </TabPane>

                                        <TabPane tab="Amount" key="amount">
                                            <FlexColumn left gap='24px'>
                                                <Flex between gap='24px'>
                                                    <LabeledInput
                                                        label="From"
                                                        id="fromAmount"
                                                        key="fromAmount"
                                                        prefix="$"
                                                        placeholder="100"
                                                        min={0}
                                                        formatter={value => `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                                        value={fromAmount}
                                                        onChange={(e) => this.setState({ 
                                                            fromAmount: (!isNaN(parseFloat(e.target.value)) ? parseFloat(e.target.value) : null),
                                                            amountError: false
                                                        })}
                                                    />
                                                    <LabeledInput
                                                        label="To"
                                                        id="toAmount"
                                                        key="toAmount"
                                                        prefix="$"
                                                        placeholder="1000"
                                                        min={0}
                                                        formatter={value => `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                                        value={toAmount}
                                                        onChange={(e) => this.setState({ 
                                                            toAmount: (!isNaN(parseFloat(e.target.value)) ? parseFloat(e.target.value) : null),
                                                            amountError: false
                                                        })}
                                                        error={amountError}
                                                        errorMessage={amountError}
                                                    />
                                                </Flex>
                                                <Button 
                                                    solid 
                                                    disabled={!(typeof(fromAmount) === 'number' && typeof(toAmount) === 'number')} 
                                                    text='APPLY' 
                                                    onClick={this.applyAmountFilter} 
                                                />
                                            </FlexColumn>
                                        </TabPane>
                                    </Tabs>
                                </Menu>
                            )}
                        >
                            <TextButton text='FILTER' rightIcon={<Image src={FilterIcon} alt="Filter" />} />
                        </Dropdown>
                    </Flex>
                </Flex>
            </Flex>
        )
    }
}

function mapStateToProps(state) {
    return {
        aionStore: state.aionAppReducer
    }
}

function mapDispatchToProps(dispatch) {
    return {
        dispatch
    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTheme(SearchFilter)));